var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';

/**
 * Slightly modified from: https://www.scottohara.me/blog/2017/04/14/inclusively-hidden.html
 */
var screenReaderOnly = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  clip: rect(0 0 0 0) !important;\n  clip-path: inset(50%) !important;\n  height: 1px !important;\n  margin: 0 !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  white-space: nowrap !important;\n  width: 1px !important;\n"])));
export { screenReaderOnly };